// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".advanced-container[data-v-70049e2b] {\n  display: none;\n  padding: 12px;\n}\n.advanced-container .is-advanced-filter-box[data-v-70049e2b] {\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  min-height: 20px;\n}\n.advanced-container.is-active[data-v-70049e2b] {\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
